var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEfectivo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_20091",
    "data-name": "Grupo 20091",
    transform: "translate(0.135)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_1883",
    "data-name": "Rect\\xE1ngulo 1883",
    transform: "translate(-0.135)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 40,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 40,
    height: 39,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "cash-svgrepo-com",
    transform: "translate(5.228 8.354)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27348",
    "data-name": "Trazado 27348",
    d: "M7,15.59c0-3.107,0-4.66,1-5.625S10.6,9,13.81,9H24.025c3.21,0,4.815,0,5.813.965s1,2.518,1,5.625v3.3c0,3.107,0,4.66-1,5.625s-2.6.965-5.813.965H13.81c-3.21,0-4.815,0-5.813-.965s-1-2.518-1-5.625v-3.3Z",
    transform: "translate(-0.19 -2.41)",
    fill: "none",
    stroke: "#777",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27349",
    "data-name": "Trazado 27349",
    d: "M9.81,21.475h0c-3.21,0-4.815,0-5.813-.965H4c-1-.965-1-2.518-1-5.625v-3.3C3,8.483,3,6.93,4,5.965S6.6,5,9.81,5H20.025c3.21,0,4.815,0,5.813.965s1,2.518,1,5.625h0",
    transform: "translate(-3 -5)",
    fill: "none",
    stroke: "#777",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27350",
    "data-name": "Trazado 27350",
    d: "M18.81,15.3A3.407,3.407,0,1,1,15.4,12,3.351,3.351,0,0,1,18.81,15.3Z",
    transform: "translate(3.322 -0.467)",
    fill: "none",
    stroke: "#777",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEfectivo);
export default __webpack_public_path__ + "static/media/icon-efectivo.2503b4bf7b78adf5de031e01f3e69620.svg";
export { ForwardRef as ReactComponent };